import React from 'react';
import { colors } from '../../style/colors';
import { TagContainer, TagTitle } from './Tag.style';

const Tag = ({ title }) => {
  const color = () => {
    const tagText = title.text;
    switch (tagText) {
      case 'panel':
        return colors.MINT;
        break;
      case 'keynote':
        return colors.YELLOW;
        break;
      case 'workshop':
        return colors.PINK;
        break;
      default:
        return undefined;
    }
  };

  return (
    <TagContainer color={color()}>
      <TagTitle color={color()}>{title.text}</TagTitle>
    </TagContainer>
  );
};

export default Tag;
